// Single source of truth for Real Estate Pro company / legal / contact details.
// No IBAN/BIC/bank details, no API keys, no third-party provider names are exposed here.

export const COMPANY = {
  brand: "Real Estate Pro",
  operator: "Willems, Marnicq",
  enterpriseNumber: "1.036.429.459",
  vat: "BE1036429459",
  address: {
    line1: "Schaapsvijver 20",
    postalCode: "3200",
    city: "Aarschot",
    country: "Belgium",
  },
  email: "realestatepro.be@gmail.com",
  // No public telephone configured yet (B2C disabled) — never render a placeholder.
  phone: null,
  addressLine: "Schaapsvijver 20, 3200 Aarschot, Belgium",
};

export const SUPPORT_EMAIL = COMPANY.email;

// Ready-to-use mailto links.
export const mailto = (subject) =>
  `mailto:${COMPANY.email}${subject ? `?subject=${encodeURIComponent(subject)}` : ""}`;

export const SUPPORT_MAILTO = mailto("Real Estate Pro support");

export const LEGAL_LINKS = [
  { to: "/terms", label: "Terms & Conditions", testid: "footer-terms" },
  { to: "/privacy", label: "Privacy Policy", testid: "footer-privacy" },
  { to: "/cookies", label: "Cookie Policy", testid: "footer-cookies" },
  { to: "/legal", label: "Legal Notice", testid: "footer-legal" },
];
